module.exports = __webpack_public_path__ + "img/ic_logout.30376e2d.svg";